import {Errors, KAError} from "@khan/logging";

export const ResumeUnownedThreadError = new KAError(
    "cannot resume a thread you do not own",
    Errors.Unauthorized,
);

export const ResumeCooldownError = new KAError(
    "cannot resume a conversation because the guide is on cooldown",
    Errors.Internal,
);

export const ResumeConversationGenericError = new KAError(
    "an error occurred while resuming the conversation",
    Errors.Internal,
);
